import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { BookingQRCode, Appeal, SvgPage, OrderQRCode } from "./pages";
import CollectEmail from "./pages/collect/email";
import "./index.less"

const Main = () => {
  return (
    <React.Fragment>
      <Route path="/h5/order-qrcode" component={OrderQRCode}></Route>
      <Route path="/h5/booking-qrcode" component={BookingQRCode}></Route>
      <Route path="/h5/svg" component={SvgPage}></Route>
      <Route path="/h5/appeal" component={Appeal}></Route>
      <Route path="/h5/collectemail" component={CollectEmail}></Route>
    </React.Fragment>
  );
}

export default Main